import React from "react";

import { Layout, ScreenHeading } from "../../webtracking/components";

import { EtaSwitcher, BranchEtaTable as EtaTable } from "../components";

const BranchEtaTable = () => {
  return (
    <Layout>
      <ScreenHeading title="ETA sucursales">
        <EtaSwitcher checked="/eta/branches" />
      </ScreenHeading>

      <div className="container has-background-light p-6 mt-5">
        <div className="notification is-info is-light">
          <strong>Nota 1</strong> Fila representa sucursal de origen, columna
          representa sucursal de destino
          <br />
          <strong>Nota 2</strong> Tiempos en días hábiles <br />
        </div>
        <EtaTable />
      </div>
    </Layout>
  );
};

export default BranchEtaTable;
